<template>
  <div class="w-screen h-screen">
    <!-- <div id="ChappMap" class="h-full w-full"></div> -->

    <l-map
      ref="map"
      @ready="onReady()"
      class="h-full w-full z-0"
      :zoom="zoom"
      :maxZoom="maxZoom"
      :center="center"
      :options="{ zoomControl: true }"
    >
      <l-tile-layer :url="urlBasemap" :attribution="attribution"></l-tile-layer>
    </l-map>

    <ficha-modal
      :showing="showFichaModal"
      :levantamientoInfo="selectedLevantamientoInfo"
      @close="closeFichaModal()"
    ></ficha-modal>

    <compartir-shared
      :showing="showShared"
      :levantamientoInfo="selectedLevantamientoInfo"
      @close="showShared=false"
    ></compartir-shared>

    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Ha ocurrido un error</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-danger-color"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <multimedia-modal
      :showing="showingMultimedia"
      :multimedia="currentMultimedia"
      @close="showingMultimedia = false"
    ></multimedia-modal>

    <multimedia-gallery-modal
      :showing="showingMultimediaGallery"
      @close="showingMultimediaGallery = false"
      :multimedia="listGalleryMultimedia"
    ></multimedia-gallery-modal>

    <div id="img-2"></div>
  </div>
</template>

<script>
import L from "leaflet";
import { LMap, LGeoJson, LTileLayer } from "vue2-leaflet";
import Vue2LeafletMarkercluster from "vue2-leaflet-markercluster";
import "leaflet.heat";
import "leaflet-geometryutil";
import EventBus from "../event-bus";
import FichaModal from "./CompartirFichaModal";
import CompartirShared from "./CompartirShared";

import buttons from "./Buttons";
import axios from "axios";
import * as turf from "@turf/turf";
import * as chartjs from "chart.js";
import AlertDialog from "./AlertDialog";
import MultimediaModal from "./MultimediaModal";
import MultimediaGalleryModal from "./MultimediaGalleryModal.vue";

// Nombre de días...
var weekday = new Array(7);
weekday[0] = "Dom";
weekday[1] = "Lun";
weekday[2] = "Mar";
weekday[3] = "Mie";
weekday[4] = "Jue";
weekday[5] = "Vie";
weekday[6] = "Sáb";

// Nombres de meses...
var month = new Array();
month[0] = "Ene";
month[1] = "Feb";
month[2] = "Mar";
month[3] = "Abr";
month[4] = "May";
month[5] = "Jun";
month[6] = "Jul";
month[7] = "Ago";
month[8] = "Sep";
month[9] = "Oct";
month[10] = "Nov";
month[11] = "Dic";

export default {
  name: "CompartirMapa",
  data: function () {
    return {
      showShared: false,
      id: null,
      updateCluster: true,
      zoom: 9,
      maxZoom: 18,
      center: [20.58651, -89.01501],
      map: null,
      valor: { selectmap: "traffic" },
      clusterOptions: { disableClusteringAtZoom: 11 },
      latLngArray: [],
      visitorMarker: "../apidev/img/visit-marker.png",
      authorityMarker: "../apidev/img/authority-marker.png",

      globalCountMaterial: 0,
      globalCountInmaterial: 0,
      globalCountNatural: 0,
      globalCountBiocultural: 0,
      globalcountTotal: 0,

      levantamientos: null,
      markers: null,
      markerCluster: null,

      showFichaModal: false,
      selectedLevantamientoInfo: {},
      urlBasemap: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      searchValue: "",
      backupLayers: null,
      currentMediaIndex: 0,
      askingForNameOfFile: false,
      fileNameToExport: null,
      filteredLevantamientos: [],
      showingSuccess: false,
      showingError: false,
      showFilters: false,
      filterByProject: false,
      filterByType: false,
      projects: [],
      projectSelected: null,
      types: [], //tipos de fichas: material, inmaterial, de proyecto
      typeSelected: null,
      errors: {
        namefile: false,
        descriptionfile: false
      },
      levantamientosHide: [],
      showHiddenLev: false,
      selectedHiddenLevInfo: {},
      showHiddenFichaModal: false,
      showingMultimedia: false,
      showingMultimediaGallery: false,
      listGalleryMultimedia: [],
      currentMultimedia: {},
      showProjectDetail: false,
      topUsers: [],
      showTopUsers: false,
    };
  },
  components: {
    LMap,
    LTileLayer,
    LGeoJson,
    buttons,
    "v-marker-cluster": Vue2LeafletMarkercluster,
    FichaModal,
    AlertDialog,
    MultimediaModal,
    MultimediaGalleryModal,
    CompartirShared
  },
  mounted() {
    if (this.$route.params.id ) {
      let id = this.$route.params.id.toString();
      this.id = atob(id)
      this.getLevantamientos();
    }
  },
  watch: {
    "valor.selectmap": function (val) {
      if (val === "traffic") {
        this.urlBasemap = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
        this.attribution =
          '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors';
      } else {
        this.urlBasemap =
          "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}";
        this.attribution =
          "Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community";
      }
    },
  },

  methods: {
    replaceURL() {
      return `../../compartir/${btoa(this.levantamientoInfo.id)}`
      //return `http://miapptsil.miatsil.org.mx/compartir/${btoa(this.levantamientoInfo.id)}`
    },
    onReady() {
      this.map = this.$refs.map.mapObject;
    },
    imgmap: function (click) {
      if (click.mapa == "traffic") {
        this.valor.selectmap = click.mapa;
      } else if (click.mapa == "satellite") {
        this.valor.selectmap = click.mapa;
      }
    },
    getLevantamientos: function () {
      console.log("GetLevantamientos");
      let that = this;

      this.globalCountMaterial = 0;
      this.globalCountInmaterial = 0;
      this.globalCountNatural = 0;
      this.globalCountBiocultural = 0;
      this.globalcountTotal = 0;

      var icon_url = "pin_azul";

      axios
        .post(
          "../apidev/levantamientos/getOneLevantamiento",
          {
            id_levantamiento: this.id
          }
        )
        .then(response => {
          console.log("RESPONSE!!!!!!!!!!!!!!!!!!!!!!!!!!!!!11", response);

          let levantamiento = response.data.levantamiento;
         
          if (levantamiento.media_array !== null) {

            let multimediaArray = JSON.parse(levantamiento.media_array);
            multimediaArray.forEach(multimedia => {
              //if (multimediaArray.length > 0) {
              multimedia.nombre = levantamiento.nombre;
              multimedia.nombre_usuario = levantamiento.nombre_usuario;
              multimedia.apellido_usuario = levantamiento.apellido_usuario;
              var TDate = new Date(levantamiento.fecha_levantamiento);
              TDate =
                weekday[TDate.getDay()] +
                " " +
                TDate.getDate() +
                " de " +
                month[TDate.getMonth()] +
                " de " +
                TDate.getFullYear();
              multimedia.TDate = TDate;
              this.listGalleryMultimedia.push(multimedia);
              //}
            });
          }

          // if (this.map.hasLayer(this.markerCluster)) {
          //   console.log("ya existe");
          //   this.markerCluster.clearLayers();
          // } else {
          //   this.markerCluster = L.markerClusterGroup({
          //     /*                 polygonOptions: {
          //           color: "#e36930"
          //         }, */
          //     spiderfyOnMaxZoom: true,
          //     chunkedLoading: true,
          //     chunkInterval: 0,
          //     showCoverageOnHover: true,
          //     zoomToBoundsOnClick: true,
          //     animate: true,
          //     animateAddingMarkers: true,
          //     //singleMarkerMode: true,
          //     //maxClusterRadius: 50,
          //     iconCreateFunction: function (cluster) {
          //       return that.createClusterIcon(cluster);
          //     }
          //   });
          //   //}).on('clusterclick',openClusterPopUp,markerClusterWS);
          //   this.map.addLayer(this.markerCluster);
          // }

            console.log("dATRA!!!!!", levantamiento.cat_principal)
            try {
              switch (levantamiento.cat_principal) {
                case "Patrimonio material":
                  icon_url = "../imgs/pin_material.png";
                  break;
                case "Patrimonio inmaterial":
                  icon_url = "../imgs/pin_inmaterial.png";
                  break;
                case "Patrimonio natural":
                  icon_url = "../imgs/pin_natural.png";
                  break;
                case "Ficha de proyecto":
                  icon_url = "../imgs/pin_biocultural.png";
                  break;
              }
            } catch (err) {
              console.log(err);
              icon_url = "../imgs/pin_azul.png";
            }
            //icon_url = "imgs/pin_azul.png";

            var levantmientoIcon = L.icon({
              iconUrl: icon_url,
              //shadowUrl: 'leaf-shadow.png',
              iconSize: [30, 30] // size of the icon
              //iconAnchor: [20, 40]
            });

            if (
              levantamiento.latitud != null &&
              levantamiento.longitud != null
            ) {
              var markerLevantamiento = L.marker(
                [levantamiento.latitud, levantamiento.longitud],
                {
                  info: levantamiento,
                  icon: levantmientoIcon
                }
              ).on("click", function (e) {
                console.log(levantamiento.nombre);
                console.log(levantamiento.id);

                that.currentMediaIndex = 0;

                //hasta que se muestre la imagen la hace 'zoomable'
                let interval = setInterval(function () {
                  let elementImage = document.querySelector("#mediaPopup");
                  if (elementImage != null) {
                    clearInterval(interval);
                    zoomer();
                  }
                }, 100);
              });

              that.selectedLevantamientoInfo = levantamiento;

              // Formateamos la fecha...
              var TDate = new Date(levantamiento.fecha_levantamiento);
              TDate =
                weekday[TDate.getDay()] +
                " " +
                TDate.getDate() +
                " de " +
                month[TDate.getMonth()] +
                " de " +
                TDate.getFullYear() +
                "<br>" +
                this.pad(TDate.getHours(), 2) +
                ":" +
                this.pad(TDate.getMinutes(), 2) +
                " hrs.";

              let levantamientoOrientation = "vertical";
              let popupWidth = "396px";
              let imageWidthPopup = "300px";
              if (levantamiento.media_metadata) {
                levantamientoOrientation =
                  levantamiento.media_metadata.imageWidth >
                  levantamiento.media_metadata.imageHeight
                    ? "horizontal"
                    : "vertical";
                imageWidthPopup =
                  levantamientoOrientation === "horizontal" ? "500px" : "300px";
                popupWidth =
                  levantamientoOrientation === "horizontal" ? "596px" : "396px";
              }

              let popuphtml = "";

              popuphtml += `
                <div style="width: ${popupWidth};">
                  <div class="flex flex-col text-center">
                    <span style='color:darkblue; font-size: 18px;'>
                      ${levantamiento.nombre}
                    </span>
                    <span style="color:${levantamiento.cat_color}; font-size: 12px;">
                      ${levantamiento.cat_principal}
                    </span>
                  </div>`;

              if (levantamiento.media_array !== null) {
                popuphtml += `
                  <div class="flex overflow-hidden items-center">
                `;
                let multimediaArray = JSON.parse(levantamiento.media_array);
                if (multimediaArray.length > 0) {
                  let firstMedia = multimediaArray[0];

                  if (firstMedia.mimeType.includes("image")) {
                    let flexSize =
                      imageWidthPopup === "500px" ? "596px" : "396px";

                    if (multimediaArray.length > 1) {
                      popuphtml += `
                      <span class="flex items-center justify-center bg-gray-900 bg-opacity-50 text-white cursor-pointer" onclick="slideToLeft();">
                        <svg xmlns="http://www.w3.org/2000/svg" class="fill-current" height="48" width="48">
                          <path d="M28.05 36 16 23.95 28.05 11.9 30.2 14.05 20.3 23.95 30.2 33.85Z"/>
                        </svg>
                      </span>
                    `;

                      if (imageWidthPopup === "500px") {
                        flexSize = "500px";
                      } else {
                        flexSize = "300px";
                      }
                    }

                    popuphtml += `
                      <div class="flex items-center justify-center select-none" style="flex: 0 0 ${flexSize};">
                        <div id="img-zoomer-box">
                          <img id="mediaPopup" class="CImg" style="max-width: ${imageWidthPopup}; max-height: 200px; margin-top: 5px; margin-bottom:10px; border: 2px solid; color: ${levantamiento.cat_color}" src="../apidev/${firstMedia.fileName}" />
                        </div>
                      </div>
                    `;

                    if (multimediaArray.length > 1) {
                      popuphtml += `
                      <span class="flex items-center justify-center bg-gray-900 bg-opacity-50 text-white cursor-pointer" onclick="slideToRight();">
                        <svg xmlns="http://www.w3.org/2000/svg" class="fill-current" height="48" width="48">
                          <path d="M18.75 36 16.6 33.85 26.5 23.95 16.6 14.05 18.75 11.9 30.8 23.95Z"/>
                        </svg>
                      </span>
                    `;
                    }
                  } else {
                    popuphtml += `
                      <video id="videoPopup" class="w-full" style="max-height: 200px;" controls src="../apidev/${firstMedia.fileName}"></video>
                    `;
                  }

                  popuphtml += `
                  </div>
                `;

                  popuphtml += `
                  <div class="flex w-full items-center justify-center my-2">
                    <button class="bg-purple-500 hover:bg-purple-700 px-4 py-2 text-center text-xs rounded-lg text-gray-100 tracking-wide" type="button" onclick="openMultimediaModal();">Ver en tamaño completo</button>
                  </div>
                `;
                }
              }

              popuphtml += `
                </div>
                <div class="flex justify-between items-center">
                  <div class="flex flex-col">
                    <span style='color: #363f43; font-size: 14px'>
                      ${levantamiento.nombre_usuario} ${levantamiento.apellido_usuario}
                    </span>
                    <span style='font-size: 12px; color:#9d9d9d;'>
                      ${TDate}
                    </span>
                  </div>
                  <div>
                    <button class="bg-purple-500 hover:bg-purple-700 px-4 py-2 text-center text-base rounded-lg text-gray-100 tracking-wide" type="button" onclick="openFichaModal();">Ver ficha</button>
                    <button class="bg-purple-500 hover:bg-purple-700 px-4 py-2 text-center text-base rounded-lg text-gray-100 tracking-wide" type="button" onclick="openShared();">Compartir</button>
                  </div>
                </div>`;

              markerLevantamiento.bindPopup(popuphtml, {
                maxWidth: "500px"
              });

              //this.markerCluster.addLayer(markerLevantamiento);
              this.map.on('popupopen', (e) => {
                var px = this.map.project(e.target._popup._latlng); // find the pixel location on the map where the popup anchor is
                px.y -= e.target._popup._container.clientHeight/2; // find the height of the popup container, divide by 2, subtract from the Y axis of marker location
                this.map.panTo(this.map.unproject(px),{animate: true}); // pan to new center
              });
              markerLevantamiento.addTo(this.map).openPopup()


              switch (levantamiento.cat_principal) {
                case "Patrimonio material":
                  this.globalCountMaterial += 1;
                  break;
                case "Patrimonio inmaterial":
                  this.globalCountInmaterial += 1;
                  break;
                case "Patrimonio natural":
                  this.globalCountNatural += 1;
                  break;
                case "Ficha de proyecto":
                  this.globalCountBiocultural += 1;
                  break;
              }
              this.globalcountTotal += 1;
            }

          // this.map.on("zoomend", function () {
          //   that.markerCluster.refreshClusters();
          // });
        })
        .catch(error => {
          console.log(error);
        });

      // zoomer();
    },
    // Formateo de números con ceros a la izquierda
    pad: function (a, b) {
      return (1e15 + a + "").slice(-b);
    },

    openMarkerPopUp: function (e) {
      console.log(e);
      console.log(this);
    },

    openFichaModal: function () {
      console.log("openFichaModal");
      this.showFichaModal = true;
      /*       this.markerLayer.clearLayers();
      this.showLevantamientoModal = false; */
    },
    openShared: function () {
      console.log("openFichaModal");
      this.showShared = true;
      /*       this.markerLayer.clearLayers();
      this.showLevantamientoModal = false; */
    },
    closeFichaModal: function () {
      console.log("closeFichaModal");
      this.showFichaModal = false;
      /*       this.markerLayer.clearLayers();
      this.showLevantamientoModal = false; */
    },
    slideToLeft() {
      let multimediaArray = JSON.parse(
        this.selectedLevantamientoInfo.media_array
      );
      if (this.currentMediaIndex > 0) {
        this.currentMediaIndex -= 1;
      } else {
        this.currentMediaIndex = multimediaArray.length - 1;
      }
      let nextMedia = multimediaArray[this.currentMediaIndex];

      if (nextMedia.mimeType.includes("image")) {
        let image = document.getElementById("mediaPopup");
        image.src = `../apidev/${nextMedia.fileName}`;
      } else {
        let video = document.getElementById("videoPopup");
        video.src = `../apidev/${nextMedia.fileName}`;
      }
    },
    slideToRight() {
      let multimediaArray = JSON.parse(
        this.selectedLevantamientoInfo.media_array
      );
      if (this.currentMediaIndex < multimediaArray.length - 1) {
        this.currentMediaIndex += 1;
      } else {
        this.currentMediaIndex = 0;
      }
      let nextMedia = multimediaArray[this.currentMediaIndex];

      if (nextMedia.mimeType.includes("image")) {
        let image = document.getElementById("mediaPopup");
        image.src = `../apidev/${nextMedia.fileName}`;
      } else {
        let video = document.getElementById("videoPopup");
        video.src = `../apidev/${nextMedia.fileName}`;
      }
    },

    checkFormDownloads: function (nameFile, descFile) {
      if (nameFile === "" || nameFile === null) {
        this.errors.namefile = true;
      } else {
        this.errors.namefile = false;
      }

      if (descFile === "" || descFile === null) {
        this.errors.descriptionfile = true;
      } else {
        this.errors.descriptionfile = false;
      }

      if (this.errors.namefile || this.errors.descriptionfile) {
        return false;
      }
      return true;
    },
    closeModalToDownloads() {
      if (this.errors.namefile) this.errors.namefile = false;
      if (this.errors.descriptionfile) this.errors.descriptionfile = false;

      this.askingForNameOfFile = false;
    },
    openMultimediaModal() {
      let multimediaArray = JSON.parse(
        this.selectedLevantamientoInfo.media_array
      );
      this.currentMultimedia = multimediaArray[this.currentMediaIndex];

      this.showingMultimedia = true;
    },

    showProjectDetailModal() {
      //console.log("project selected: ", this.projectSelected)
      this.showProjectDetail = true;
      EventBus.$emit("showProjectDetail", {
        id_proyecto: this.projectSelected
      });
    },
    defaultProfile: function (user) {
      user.profile_image =
        "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png";
    }
  },

  created() {
    let that = this;
    console.log("created");
    window.openFichaModal = this.openFichaModal.bind(this);
    window.openShared = this.openShared.bind(this);
    window.slideToLeft = this.slideToLeft.bind(this);
    window.slideToRight = this.slideToRight.bind(this);
    window.openMultimediaModal = this.openMultimediaModal.bind(this);
  },
  computed: {
    styleGeojsonChapp() {
      return () => {
        return {
          color: "#cb2833",
          fill: false
        };
      };
    },
    options() {
      return {
        pointToLayer: function (feature, latlng) {
          let color = "";
          let fillColor = "";

          switch (feature.properties.status) {
            case "no atendida":
              color = "#000";
              fillColor = "#cb2833";
              break;
            case "en proceso":
              color = "#000";
              fillColor = "#ffc200";
              break;
            case "Cerradas":
            case "atendida":
              color = "#000";
              fillColor = "#898d8d";
              break;
            default:
              color = "#000";
              fillColor = "#cb2833";
              break;
          }

          return L.circleMarker(latlng, {
            radius: 8,
            fillColor: fillColor,
            color: color,
            weight: 1,
            opacity: 1,
            fillOpacity: 0.8
          });
        }
      };
    },
    optionsVisitor() {
      return {
        pointToLayer: function (feature, latlng) {
          var icon = new L.Icon({
            iconUrl: "../apidev/img/visit-marker.png",
            iconSize: [41, 41],
            iconAnchor: [41, 41],
            popupAnchor: [-20, -45],
            shadowSize: [41, 41],
            prefix: "icon"
          });

          return L.marker(latlng, {
            icon: icon
          }).bindPopup(
            `
            <div class="flex flex-col">
              <span class="text-gray-700 text-sm font-semibold">Sexo: <span class="font-normal">${
                feature.properties.sex === "H" ? "Hombre" : "Mujer"
              }</span></span>
              <span class="text-gray-700 text-sm font-semibold">Edad: <span class="font-normal">${
                feature.properties.age
              }</span></span>
              <span class="text-gray-700 text-sm font-semibold">Nivel de estudios: <span class="font-normal">${
                feature.properties.nivel_estudios
              }</span></span>
            </div>
            `
          );
        }
      };
    },
    optionsAuthorities() {
      return {
        pointToLayer: function (feature, latlng) {
          var icon = new L.Icon({
            iconUrl: "../apidev/img/authority-marker.png",
            iconSize: [41, 41],
            iconAnchor: [41, 41],
            popupAnchor: [-20, -45],
            shadowSize: [41, 41],
            prefix: "icon"
          });

          return L.marker(latlng, {
            icon: icon
          }).bindPopup(
            `
            <div class="flex flex-col">
              <span class="text-gray-900 text-sm font-bold tracking-wide">${
                feature.properties.name
              } ${feature.properties.last_name}</span>
              <span class="text-gray-700 text-sm font-semibold">ID: <span class="font-normal">${
                feature.properties.auth_id
              }</span></span>
              <span class="text-gray-700 text-sm font-semibold">Tel.: <span class="font-normal">${
                feature.properties.phone_number
              }</span></span>
              <span class="text-gray-700 text-sm font-semibold">Sexo: <span class="font-normal">${
                feature.properties.sex === "H" ? "Hombre" : "Mujer"
              }</span></span>
              <span class="text-gray-700 text-sm font-semibold">Edad: <span class="font-normal">${
                feature.properties.age
              }</span></span>
              <span class="text-gray-700 text-sm font-semibold">Categoría: <span class="font-normal">${
                feature.properties.authority_category_name
              }</span></span>
            </div>
            `
          );
        }
      };
    }
  }
};

let zoomer = function () {
  console.log("zoomer");
  //let el=document.querySelector('#img-zoomer-box');
  let el = document.querySelector("#mediaPopup");
  //console.log(el)
  el.addEventListener(
    "mousemove",
    function (e) {
      // console.log('mousemove')
      let original = document.querySelector("#mediaPopup"); //#img-1
      //console.log(original.src)
      let magnified = document.querySelector("#img-2");
      let style = magnified.style;
      let x = e.pageX - this.offsetLeft;
      let y = e.pageY - this.offsetTop;
      let imgWidth = original.offsetWidth;
      let imgHeight = original.offsetHeight;
      let xperc = (x / imgWidth) * 100;
      let yperc = (y / imgHeight) * 100;

      /*     console.log(e.pageX, e.pageY)
    console.log(imgWidth, imgHeight)
    console.log(x,y) */

      var rect = e.target.getBoundingClientRect();
      var newx = e.clientX - rect.left; //x position within the element.
      var newy = e.clientY - rect.top; //y position within the element.
      //console.log("Left? : " + newx + " ; Top? : " + newy + ".");

      //lets user scroll past right edge of image
      if (x > 0.01 * imgWidth) {
        xperc += 0.15 * xperc;
      }

      //lets user scroll past bottom edge of image
      if (y >= 0.01 * imgHeight) {
        yperc += 0.15 * yperc;
      }

      let newPercentx = (newx * 100) / imgWidth;
      let newPercentY = (newy * 100) / imgHeight;

      style.backgroundImage = "url('" + original.src + "')";
      style.backgroundPositionX = newPercentx + "%";
      style.backgroundPositionY = newPercentY + "%";
      /*     style.backgroundPositionX = (xperc - 9) + '%';
    style.backgroundPositionY = (yperc - 9) + '%'; */

      //console.log(style.backgroundPositionX,style.backgroundPositionY)

      style.left = x - 180 + "px";
      style.top = y - 180 + "px";
    },
    false
  );

  el.addEventListener(
    "mouseenter",
    function (e) {
      //console.log('mouseenter')
      let magnified = document.querySelector("#img-2");
      let style = magnified.style;
      style.opacity = 1;
      style.display = "block";
    },
    false
  );

  el.addEventListener(
    "mouseleave",
    function (e) {
      //console.log('mouseleave')
      let magnified = document.querySelector("#img-2");
      let style = magnified.style;
      style.display = "none";
      style.opacity = 0;
    },
    false
  );
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.clusterTextPosition {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.clusterText {
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  font-weight: bolder;
  font-size: 130%;
  color: white;
}

.sentiments {
  z-index: -999 !important;
}

.CImg {
  border-radius: 10px;
  background-color: #ffffff;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  /* box-shadow: 0 0 8px rgba(0, 0, 0, 0.8);
  -webkit-box-shadow: 0 0 8px rgba(0, 0, 0, 0.8);
  -moz-box-shadow: 0 0 8px rgba(0, 0, 0, 0.8); */
  -webkit-transition: all 0.25s ease-in-out;
  -moz-transition: all 0.25s ease-in-out;
  -o-transition: all 0.25s ease-in-out;
  transition: all 0.25s ease-in-out;
}

.Crop {
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

hr {
  border-top-width: 3px;
  border-color: #b792f7;
}

.leaflet-popup-content {
  width: auto !important;
}

.button {
  border: none;
  color: white;
  padding: 8px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  transition-duration: 0.4s;
  cursor: pointer;
}

.button1 {
  background-color: #4caf50;
  color: black;
  border: 2px solid #4caf50;
}

.button1:hover {
  background-color: #136115;
  border: 2px solid #136115;
  color: white;
}

.button2 {
  background-color: white;
  color: black;
  border: 2px solid #008cba;
}

.button2:hover {
  background-color: #008cba;
  color: white;
}

.selectMun {
  width: 25em;
  max-width: 30em;
  /* margin: 1em auto; */
}

/****** */

#img-zoomer-box {
  /* width: 500px; */
  /* height: auto; */
  position: relative;
  margin-top: 10px;
}

#img-1 {
  width: 100%;
  height: auto;
}

#img-zoomer-box:hover,
#img-zoomer-box:active {
  cursor: zoom-in;
  display: block;
}

#img-zoomer-box:hover #img-2,
#img-zoomer-box:active #img-2 {
  opacity: 1;
}
#img-2 {
  /* border: 1px solid rgb(0, 0, 0); */
  width: 340px;
  height: 340px;
  background: url("https://bit.ly/2mgDw0y") no-repeat #fff;
  box-shadow: 0 5px 10px -2px rgba(0, 0, 0, 0.3);
  pointer-events: none;
  position: absolute;
  opacity: 0;
  border: 4px solid whitesmoke;
  z-index: 99999999999;
  border-radius: 10%;
  /* display: block; */
  display: none;
  transition: opacity 0.2s;
}
</style>
